import { Heading, Box } from 'grommet'
import styled, { css } from 'styled-components'

import { NormalizedWrapper } from '@theme'

const WRAPPER_MIN_HEIGHT = 700
const TITLE_HEIGHT = 135
const TITLE_WIDTH = 491
const CONTAINER_IMAGE_WIDTH = 621
const HEXAGON_WRAPPER_WIDTH = 136

export const ContentWrapper = styled(NormalizedWrapper)`
  align-items: center;
  display: flex;
  justify-content: space-between;
  justify-content: space-around;
  position: relative;

  ${({ theme }) => theme.below.laptop`
    display: flex;
    flex-direction: column;
  `}
`

export const ContainerInfo = styled(Box)`
  ${({ theme }) => css`
    ${theme.below.laptopL`
      margin-right: 0px;
   `}

    ${theme.below.laptopL`
      flex:1;
      margin-top: ${theme.newSpaces.xl3}px;
      margin-bottom: ${theme.newSpaces.md}px;
    `}

    ${theme.below.mobileXL`
      max-width: 90%;
    `}
  `}
`

export const Wrapper = styled(Box)`
  background: ${({ background }) => background};
  color: ${({ textColor }) => textColor};
  justify-content: center;
  min-height: ${WRAPPER_MIN_HEIGHT}px;
  z-index: 1;

  ${({ theme }) => css`
    margin-bottom: ${theme.newSpaces.xl3}px;
    padding-bottom: ${theme.newSpaces.xl10}px;
  `}
`

export const Title = styled(Heading)`
  ${({ theme }) => css`
    align-self: start;
    font-size: ${theme.typography.desktop.title.title1.fontSize}px;
    height: ${TITLE_HEIGHT}px;
    line-height: ${theme.typography.mobile.title.large.lineHeight}px;
    white-space: pre-wrap;
    width: ${TITLE_WIDTH}px;

    ${theme.below.laptop`
      text-align: center;
      align-self: center;
    `}

    ${theme.below.tablet`
      max-width: 100%;
    `}

    ${theme.below.mobileXL`
      font-size: ${theme.typography.mobile.title.blog.fontSize}px;
      line-height: initial;
    `}

    ${theme.below.mobileL`
      font-size: 27px;
    `}

    ${theme.below.mobileM`
      font-size: ${theme.typography.mobile.title.title2.fontSize}px;
    `}

    ${theme.below.mobileS`
      font-size: 20px;
    `}
  `}
`

export const ContainerImage = styled(Box)`
  ${({ theme }) => css`
    background: none;
    height: auto;
    margin-top: ${theme.newSpaces.xl7}px;
    width: ${CONTAINER_IMAGE_WIDTH}px;

    img {
      height: auto;
      object-fit: contain;
      width: 100%;
    }

    ${theme.below.laptop`
      width: 80%;
      margin-left: 100px;
      margin-top: 0px;
    `}

    ${theme.below.laptopL`
      flex:1;
      margin-left: 0px;
    `}
  `}
`

export const HexagonWrapper = styled(Box)`
  ${({ theme }) => css`
    align-self: center;
    height: ${theme.newSpaces.xs}px;
    width: ${HEXAGON_WRAPPER_WIDTH}px;

    ${theme.below.laptop`
      margin-top: ${theme.newSpaces.md}px;
   `}
  `}
`
